import { ExportFileType } from '@common/ts/enums';
import { Input } from '@/components/ui/input';
import { FileTypeToggleProps } from '@/types';

function ExportFileTypeToggle({ fileType, setFileType }: FileTypeToggleProps) {
  // fileTypes are ['xlsx', 'csv', 'txt'] — xlsx first (default).
  const filteTypes = Object.values(ExportFileType);

  return (
    // shrink-0: the radio group is the fixed-size part of the export row — when space
    // is tight the dropdown label truncates instead of the radios collapsing or
    // spilling out of the dialog (TELV1-474).
    <div className="flex gap-2 items-center shrink-0">
      {filteTypes.map((type) => (
        <div key={type} className="flex items-center gap-1">
          <Input
            type="radio"
            checked={fileType === type}
            onChange={() => setFileType(type)}
            id={`filetype-${type}`}
            className="cursor-pointer shadow-none w-4 h-4"
          />
          <label htmlFor={`filetype-${type}`} className="cursor-pointer text-sm">
            .{type}
          </label>
        </div>
      ))}
    </div>
  );
}

export default ExportFileTypeToggle;
